const Path = "https://levashubhmangal.com/web_service_14072020/";

export default Path;